export default __webpack_public_path__ + "static/media/mebloscianki2.172b625e.jpg";